<template>
  <CModal :centered="true" :show.sync="viewReportModal" size="md" title="گزارش">
    <div class="text-right">
      <div class="desc text-sm"></div>
      <CForm>
        <div v-if="typeDate.length" class="d-flex text-sm mt-2">
          <div class="ml-1 flex-fill">
            <div class="mb-1">از تاریخ</div>
            <date-picker
                v-model="form.dateFrom"
                auto-submit
                color="#fbad18"
                format="jYYYY-jMM-jDD"
            />
          </div>
          <div class="mr-1 flex-fill">
            <div class="mb-1">تا تاریخ</div>
            <date-picker
                v-model="form.dateTo"
                auto-submit
                color="#fbad18"
                format="jYYYY-jMM-jDD"
            />
          </div>
        </div>
        <div v-if="typeKlass.length || typeGrade.length" class="d-flex mt-3">
          <CSelect
              :options="computedGrades"
              :value.sync="form.grade"
              class="CSelectStyle flex-fill"
              placeholder="پایه"
              @update:value="getKlasses"
          />
          <CSelect
              v-if="!typeGrade.length || (typeKlass.length && typeGrade.length)"
              :options="computedKlasses"
              :value.sync="form.klass"
              class="CSelectStyle flex-fill mr-2"
              placeholder="کلاس"
          />
        </div>
        <div v-if="typeCourse.length">
          <CSelect
              :options="computedCourses"
              :value.sync="form.course"
              class="CSelectStyle"
              placeholder="درس"
              @update:value="getCourses"
          />
        </div>
        <div v-if="typeTeacher.length">
          <CInput
              v-model="form.teacherNationalId"
              label="شماره‌ی ملی معلم"
              maxlength="10"
              type="number"
          />
        </div>
        <div v-if="typeStudent.length">
          <CInput
              v-model="form.studentNationalId"
              label="شماره‌ی ملی دانش آموز"
              maxlength="10"
              type="number"
          />
        </div>
      </CForm>
    </div>

    <template #footer>
      <CButton
          class="px-4"
          color="primary"
          @click="onSubmitReport"
          :disabled="loading"
      >
        دریافت گزارش
      </CButton>
      <CButton class="modal-button px-4" @click="viewReportModal = false">
        انصراف
      </CButton>
    </template>
  </CModal>
</template>
<script>
import axios from "@/plugins/axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {datePicker: VuePersianDatetimePicker},
  props: {
    value: {
      type: Boolean,
    },
    report: {
      type: Object,
    },
  },
  data() {
    return {
      form: {},
      loading: false,
      grades: [],
      klasses: [],
      students: [],
      courses: [],
    };
  },
  computed: {
    viewReportModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedPayload() {
      return this.report.parameters.map((item) => {
        return {
          title: item.title,
          key: item.key,
          type: item.type,
          value:
              item.type === "STUDENT"
                  ? this.form.studentNationalId
                  : item.type === "TEACHER"
                      ? this.form.teacherNationalId
                      : item.type === "KLASS"
                          ? this.form.klass
                          : item.type === "GRADE"
                              ? this.form.grade
                              : item.type === "COURSE"
                                  ? this.form.course
                                  : item.key === "dateFrom"
                                      ? this.form.dateFrom
                                      : item.key === "dateTo"
                                          ? this.form.dateTo
                                          : "",
        };
      });
    },

    computedGrades() {
      return this.grades.map((item) => {
        return {
          ...item,
          value: `${item.id}`,
          label: `${item.name}`,
        };
      });
    },
    computedKlasses() {
      return this.klasses.map((item) => {
        return {
          value: `${item.id}`,
          label: `${item.name}`,
        };
      });
    },
    computedCourses() {
      return this.courses.map((item) => {
        return {
          value: `${item.id}`,
          label: `${item.name} ${item.klass.grade.name} ${item.klass.name}`,
        };
      });
    },
    typeKlass() {
      return this.report.parameters.filter((item) => item.type === "KLASS");
    },
    typeGrade() {
      return this.report.parameters.filter((item) => item.type === "GRADE");
    },
    typeCourse() {
      return this.report.parameters.filter((item) => item.type === "COURSE");
    },
    typeDate() {
      return this.report.parameters.filter((item) => item.type === "DATE");
    },
    typeTeacher() {
      return this.report.parameters.filter((item) => item.type === "TEACHER");
    },
    typeStudent() {
      return this.report.parameters.filter((item) => item.type === "STUDENT");
    },
  },
  mounted() {
    this.getGrades();
    this.getCourses();
  },
  methods: {
    async getGrades() {
      try {
        this.loading = true;
        const {data} = await axios.get("/grade");
        this.grades = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getKlasses(gradeId) {
      try {
        this.loading = true;
        this.klasses = [];
        const {data} = await axios.get(`/grade/${gradeId}/klass`);
        this.klasses = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getCourses() {
      try {
        this.loading = true;
        const {data} = await axios.get("/course");
        this.courses = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async onSubmitReport() {
      try {
        this.loading = true;

        await axios
            .post(`/report/${this.report.id}`, this.computedPayload)
            .then((response) => {
              window.open(response.data.url);
              this.form = {};
              this.viewReportModal = false;
            });
      } catch (error) {
        console.log("errrror:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.desc {
  word-wrap: break-word;
  white-space: pre-line;
  font-size: 14px;
  line-height: 1.5;
}
</style>